// The Contracts page moved onto each building (V0.4.2). Old links land on the building that holds the contract.
import { useEffect } from 'react';
import { useNavigate, useSearchParams } from 'react-router';
import { supabase } from '../lib/supabase';
import { Empty } from '../ui/kit';

export default function Contracts() {
  const nav = useNavigate();
  const [params] = useSearchParams();
  useEffect(() => {
    const id = params.get('open') ?? params.get('id');
    if (!id) return void nav('/buildings', { replace: true });
    void supabase
      .from('contracts')
      .select('building_ids')
      .eq('id', id)
      .maybeSingle()
      .then(({ data }) => {
        const b = (data as { building_ids: string[] } | null)?.building_ids?.[0];
        nav(b ? `/buildings/${b}` : '/buildings', { replace: true });
      });
  }, [params, nav]);
  return <Empty>Contracts now live on each building — opening Buildings &amp; projects…</Empty>;
}
